import { combineReducers } from 'redux';

import list from './list';
import selected from './selected';
import form from './form';

export default combineReducers({
  list,
  selected,
  form,
});
